export enum DraftProbeStatus {
  EXISTS = 'EXISTS',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}
